import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AiSummaryComponent } from "./ai-summary.component";

@NgModule({
	imports: [CommonModule],
	declarations: [AiSummaryComponent],
	exports: [AiSummaryComponent]
})
export class AiSummaryModule { }
